export default function (input: number, decimals = 1) {
	return input.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
}
